import type { AccountInfo, AuthenticationResult, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { Faker, base, en } from "@faker-js/faker";
import type { Decorator } from "@storybook/react-vite";
import { msalManagementInstance } from "../auth/msalManagement.ts";

const faker = new Faker({ locale: [base, en], seed: 42 });
faker.setDefaultRefDate(new Date("2024-05-01"));

const account: AccountInfo = {
    tenantId: "eb39acb7-fae3-4bc3-974c-b765aa1d6355",
    username: "Sam Altam",
    name: "Sam Altam",
    homeAccountId: faker.git.commitSha(),
    environment: "local",
    localAccountId: faker.git.commitSha()
};

const authenticationResult: AuthenticationResult = {
    tenantId: "eb39acb7-fae3-4bc3-974c-b765aa1d6355",
    idToken: faker.git.commitSha(),
    accessToken: faker.git.commitSha(),
    authority: faker.company.name(),
    scopes: [],
    tokenType: "Camusel",
    idTokenClaims: {
        roles: ["Assessor"]
    },
    account,
    uniqueId: faker.git.commitSha(),
    fromCache: true,
    expiresOn: faker.date.anytime(),
    correlationId: faker.git.commitSha()
};

export function injectMockMsal(publicClientApplication: PublicClientApplication) {
    publicClientApplication.acquireTokenSilent = () => {
        return Promise.resolve(authenticationResult);
    };

    publicClientApplication.getActiveAccount = () => {
        return account;
    };

    publicClientApplication.getAllAccounts = () => {
        return [account];
    };

    publicClientApplication.logout = async () => {};
}

export const msalDecorator: Decorator = Story => {
    injectMockMsal(msalManagementInstance);

    return (
        <MsalProvider instance={msalManagementInstance}>
            <Story />
        </MsalProvider>
    );
};
